export const actions = {
  SELLER_LOGIN: "SELLER_LOGIN",
  SELLER_LOGOUT: "SELLER_LOGOUT",
  SET_SELLER: "SET_SELLER",
  SET_SELLER_TOKEN: "SET_SELLER_TOKEN",
};
